module.exports = __webpack_public_path__ + "static/media/tangoapp.666470e1.png";